export const networkLogStyle = `.main-network-log-wrapper {
  z-index: 9;
  padding: 5px;
  position: fixed;
  margin-left: auto;
  margin-right: 0;
  color: #000;
  top: 0;
  right: 0;

  .network-snapShot,
  .network-recording-off,
  .network-recording-start,
  .network-reset-mode {
    border-radius: 4px;
    color: #000;
    padding: 5px;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    font-size: 16px;
    margin: 4px 2px;
    transition-duration: 0.4s;
    cursor: pointer;
    min-width: auto;
  }

  .network-recording-start,
  .network-snapShot {
    color: #000;
    border: 1px solid #90ee90;
    background-color: #90ee90;
  }
  .network-recording-off {
    border: 1px solid #ff0000cf;
    background: #ff0000cf;
    border-color: #ff0000cf;
  }

  .network-recording-start:hover,
  .network-snapShot:hover {
    background-color: #46a646;
  }

  .network-recording-off:hover {
    background: #ff0000cf;
  }

  .enabledButton:hover {
    background-color: #90ee90;
    border: 1px solid #90ee90;
    color: #000;
  }

  .disableButton {
    background-color: none;
    border-color: none;
    cursor: not-allowed;
    opacity: 0.6;
  }

  .inActiveLog {
    display: none !important;
  }
}`;
